import * as React from "react";

import { OccupationalIllness } from "../models";
import { OccupationalIllnessApi } from "../occupationalIllnessApi";

import { CreateEditModal } from "./CreateEditModal";

interface Props {
    onCreated: (occupationalIllness: OccupationalIllness) => void;
}

export const Create: React.FunctionComponent<Props> = ({ onCreated }: Props) => {
    return (
        <CreateEditModal
            title="Create Occupational Illness"
            occupationalIllness={{
                hasBeenAbsent: false,
                category: undefined,
                description: "",
                descriptionOfFurtherAction: "",
                diagnosedOrSuspected: undefined,
                firstDayOfAbsence: undefined,
                illnessStarted: undefined,
                injuryOrIllness: undefined,
                lastDayOfAbsence: undefined,
                linkedOhCaseId: "",
                oshaReportable: false,
                astraZenecaLocalSheReportableChange: false,
                dateReportedToTheSheTeam: undefined,
                reported: false,
                riddorReportable: false,
            }}
            onSaved={onCreated}
            saveModel={OccupationalIllnessApi.create}
        />
    );
};
